export const IconGolRecibed = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,1.1L12.6,1.1c6.4,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5
		l0,0C6.3,24.1,1.1,19,1.1,12.6l0,0C1.1,6.3,6.3,1.1,12.6,1.1z"
          fill="#FFEDED"
        />
        <path
          d="M12.6,1.8L12.6,1.8
		c6,0,10.8,4.8,10.8,10.8l0,0c0,6-4.8,10.8-10.8,10.8l0,0c-6,0-10.8-4.8-10.8-10.8l0,0C1.8,6.7,6.7,1.8,12.6,1.8z"
          fill="none"
          stroke="#FFEDED"
          strokeWidth="1.4133"
        />
      </g>
      <path
        d="M20,7.1H5.2c-0.6,0-1,0.5-1,1v9.1c0,0.4,0.4,0.8,0.8,0.8h0.5c0.4,0,0.8-0.4,0.8-0.8V9.7c0,0,0.1,0,0.1,0
	c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.3h12c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0v7.6
	c0,0.4,0.4,0.8,0.8,0.8h0.5c0.4,0,0.8-0.4,0.8-0.8v-9C21.1,7.7,20.6,7.1,20,7.1z M20.5,17.3c0,0.1-0.1,0.2-0.2,0.2h-0.5
	c-0.1,0-0.2-0.1-0.2-0.2V8.7h-14v8.6c0,0.1-0.1,0.2-0.2,0.2H4.9c-0.1,0-0.2-0.1-0.2-0.2V8.2c0-0.2,0.2-0.4,0.4-0.4H20
	c0.3,0,0.5,0.2,0.5,0.5V17.3z"
        fill="#D84638"
      />
      <path
        d="M7.1,16.3l-0.5,0.4c-0.1,0.1-0.2,0.3-0.1,0.4c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1l0.5-0.4
	c0.1-0.1,0.2-0.3,0.1-0.4C7.4,16.2,7.2,16.2,7.1,16.3z"
        fill="#D84638"
      />
      <path
        d="M7.9,10.5L7.5,10C7.3,9.9,7.1,9.9,7,10s-0.1,0.3,0,0.4l0.4,0.4C7.5,11,7.6,11,7.7,11c0.1,0,0.2,0,0.2-0.1
	C8,10.8,8,10.6,7.9,10.5z"
        fill="#D84638"
      />
      <path
        d="M8.1,14c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3v-0.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3V14
	z"
        fill="#D84638"
      />
      <path
        d="M8.4,12.5c0.2,0,0.3-0.1,0.3-0.3v-0.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v0.6
	C8.1,12.4,8.2,12.5,8.4,12.5z"
        fill="#D84638"
      />
      <path
        d="M16.6,14c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3v-0.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3
	V14z"
        fill="#D84638"
      />
      <path
        d="M16.9,12.5c0.2,0,0.3-0.1,0.3-0.3v-0.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v0.6
	C16.6,12.4,16.7,12.5,16.9,12.5z"
        fill="#D84638"
      />
      <path
        d="M18.8,16.5l-0.5-0.3c-0.1-0.1-0.3,0-0.4,0.1c-0.1,0.1,0,0.3,0.1,0.4l0.5,0.3c0.1,0,0.1,0,0.2,0
	c0.1,0,0.2-0.1,0.3-0.1C18.9,16.7,18.9,16.6,18.8,16.5z"
        fill="#D84638"
      />
      <path
        d="M18.2,10.5c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-0.4,0.4c-0.1,0.1-0.1,0.3,0,0.4
	c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1L18.2,10.5z"
        fill="#D84638"
      />
      <path
        d="M17.2,15.5L17.2,15.5l0-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v0.4c0,0.1,0.1,0.2,0.1,0.3
	l0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.1C17.4,15.8,17.4,15.6,17.2,15.5z"
        fill="#D84638"
      />
      <path
        d="M10.8,15.3h-0.6c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h0.6c0.2,0,0.3-0.1,0.3-0.3
	C11.1,15.5,11,15.3,10.8,15.3z"
        fill="#D84638"
      />
      <path
        d="M9,15.3H8.7v-0.1c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3v0.2l0,0C7.9,15.6,7.9,15.8,8,16
	C8,16,8.1,16.1,8.2,16.1c0.1,0,0.1,0,0.2-0.1l0.1-0.1H9c0.2,0,0.3-0.1,0.3-0.3C9.3,15.5,9.2,15.3,9,15.3z"
        fill="#D84638"
      />
    </svg>
  );
};
